export const MODELS = [
  // Claude models
  { id: "claude-opus-4-8", value: "claude-opus-4-8", label: "Claude Opus 4.8" },

  { id: "claude-opus-4-7", value: "claude-opus-4-7", label: "Claude Opus 4.7" },
  {
    id: "claude-sonnet-4-6",
    value: "claude-sonnet-4-6",
    label: "Claude Sonnet 4.6",
  },

  // OpenAI models
  {
    id: "gpt-5-5-instant",
    value: "gpt-5.5",
    label: "GPT 5.5 Instant",
  },
  {
    id: "gpt-5-5-pro",
    value: "gpt-5.5-pro",
    label: "GPT 5.5 Pro",
  },

  // Gemini models
  {
    id: "gemini-3-5-flash",
    value: "gemini-3.5-flash",
    label: "Gemini 3.5 Flash",
  },
  { id: "gemini-3-1-pro", value: "gemini-3.1-pro", label: "Gemini 3.1 Pro" },
];
